import React from 'react';

import { Label, Container} from 'semantic-ui-react'

class Contact extends React.Component {
  render ()
  {
      return <React.Fragment>
            <Container>
                <Label style={{ backgroundColor: "#00ff00"}} horizontal  size='big'>
                    Contact Us
                </Label>
               <p>donalireland@gmail.com</p>
            </Container>
        </React.Fragment>
    }
};
export default Contact;
